module.exports = __webpack_public_path__ + "img/couple_雙人合盤.bc925424.svg";